










import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {TeamModel} from '@/models/team.model';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import TeamCard from '@/components/Shared/TeamCard.vue';

@Component({
  components: {TeamCard}
})
export default class ListTeamItem extends Vue {
  @Prop({required: true}) team!: TeamModel;
  cardLoader = false;

  onTeamSelected(team: TeamModel) {
    if (team.slug && team.challenge_id) {
      this.cardLoader = true;
      new ChallengesApi().findById(team.challenge_id)
        .pipe(take(1))
        .subscribe((challenge) => {
          this.$router.push({
            name: 'show-team-members', params: {
              teamSlug: `${team.slug}`,
              slug: `${challenge.slug}`
            }
          })
        });
    }
  }
}
